/**
 * The available dashboard filtration / sorting options
 */
import {ts_translate} from "./clientTranslate";

export const TASKS_SORTINGS = {
    week: 'Wochenansicht',
    erpNum: ts_translate('ERP-Nr.'),
    client: 'Kunden',
    workplace: 'Arbeitsplatz',
    skip: 'Artikel-Nr.',
    workStep: 'Arbeitsschritt',
};

/**
 * The default batch size of the task quantity
 */
export const TASKS_QUANTITY_BATCH_SIZE = 50;

/**
 * The format for the full date representation
 */
export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';



// WEBPACK FOOTER //
// ./src/common/constants.js